module.exports = "<p class=\"group-title\">{{ title }}</p><ng-content select=\"\"></ng-content>";